import React, { useState } from "react";
import { X, ZoomIn } from "lucide-react";
import { ASSETS } from "../lib/assets";

const DEFAULT_ALT = "When Pigs Fly Family BBQ menu — Platters, Sides, Loaded Mac & Cheese, Loaded Potatoes, Combo Platters, Desserts, and Drinks.";

/**
 * Menu card that opens into a full-screen zoomable lightbox on click / tap.
 * Pass a custom `src` + `alt` for other menu sides (back of menu, catering, etc.).
 */
export default function MenuCardWithLightbox({
  className = "",
  framed = true,
  testid = "menu-card-image",
  src = ASSETS.menuCard,
  alt = DEFAULT_ALT,
}) {
  const [open, setOpen] = useState(false);

  return (
    <>
      <button
        type="button"
        onClick={() => setOpen(true)}
        data-testid={testid}
        className={`group relative block w-full cursor-zoom-in overflow-hidden ${framed ? "border-2 border-bone shadow-hard-invert" : ""} ${className}`}
        aria-label="Open menu in full-screen viewer"
      >
        <img
          src={src}
          alt={alt}
          className="block h-auto w-full transition-transform duration-500 group-hover:scale-[1.01]"
          loading="lazy"
        />
        <span className="absolute right-3 top-3 inline-flex items-center gap-2 border border-bone/70 bg-ink/70 px-3 py-1.5 font-mono text-[10px] uppercase tracking-[0.2em] text-bone backdrop-blur-sm">
          <ZoomIn size={12} /> Tap to zoom
        </span>
      </button>

      {open && (
        <div
          className="fixed inset-0 z-[100] flex items-center justify-center bg-ink/95 p-2 md:p-6"
          onClick={() => setOpen(false)}
          data-testid="menu-lightbox"
        >
          <button
            type="button"
            onClick={(e) => { e.stopPropagation(); setOpen(false); }}
            aria-label="Close menu"
            data-testid="menu-lightbox-close"
            className="fixed right-4 top-4 z-[101] flex h-11 w-11 items-center justify-center border-2 border-bone bg-ink text-bone transition-colors duration-200 hover:bg-bone hover:text-ink md:right-6 md:top-6"
          >
            <X size={20} />
          </button>
          <div
            className="relative max-h-[95vh] max-w-[100vw] overflow-auto"
            onClick={(e) => e.stopPropagation()}
          >
            <img
              src={src}
              alt={alt}
              className="block h-auto w-auto max-w-none touch-pan-x touch-pan-y select-none"
              style={{ maxHeight: "95vh" }}
              draggable="false"
              data-testid="menu-lightbox-image"
            />
          </div>
          <div className="pointer-events-none fixed bottom-4 left-1/2 -translate-x-1/2 border border-bone/40 bg-ink/70 px-3 py-1.5 font-mono text-[10px] uppercase tracking-[0.2em] text-bone/80 backdrop-blur-sm">
            Pinch or scroll to zoom · Tap outside to close
          </div>
        </div>
      )}
    </>
  );
}
